import type { MouseEvent } from 'react';

import classNames from 'classnames';
import { redirect } from 'saddlebag-browser';

import {
  BpkButtonV2,
  BUTTON_TYPES,
} from '@skyscanner/backpack-web/bpk-component-button';
import { withRtlSupport } from '@skyscanner/backpack-web/bpk-component-icon';
import LongArrowIcon from '@skyscanner/backpack-web/bpk-component-icon/sm/long-arrow-right';
import BpkPrice, { ALIGNS } from '@skyscanner/backpack-web/bpk-component-price';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text/src/BpkText';

import type { ProviderInfo } from '@skyscanner-internal/landing-pages-shared-types/types-shared/ProviderRating';

import STYLES from './Footer.module.scss';

const LongArrowRight = withRtlSupport(LongArrowIcon);

const onClick = (e: MouseEvent<Element>, props: ProviderInfo) => {
  e.stopPropagation();

  redirect(props.link, props.isOpenInNewTab);
};

const Footer = ({
  provider,
  strings,
}: {
  provider: ProviderInfo;
  strings: { [key: string]: string };
}) => {
  const { ariaLabelPrice, price, providerName } = provider;
  return (
    <div
      className={classNames(STYLES.Footer, {
        [STYLES.Footer__noPrice]: !price,
      })}
    >
      {price && (
        <div
          className={STYLES.Footer__price}
          aria-label={ariaLabelPrice}
          role="status"
        >
          <BpkPrice
            align={ALIGNS.left}
            leadingText={strings.from}
            price={price}
            trailingText={strings.perDay}
          />
        </div>
      )}
      <BpkButtonV2
        className={STYLES.Footer__view}
        onClick={(e: MouseEvent<Element>) => onClick(e, provider)}
        type={BUTTON_TYPES.link}
        implicit
      >
        <BpkText textStyle={TEXT_STYLES.label1}>
          {strings.view.replace(/@@provider@@/g, providerName)}
        </BpkText>
        <LongArrowRight />
      </BpkButtonV2>
    </div>
  );
};

export default Footer;
